import { render, staticRenderFns } from "./LatestArticles.vue?vue&type=template&id=30013515&scoped=true&"
import script from "./LatestArticles.vue?vue&type=script&lang=js&"
export * from "./LatestArticles.vue?vue&type=script&lang=js&"
import style0 from "./LatestArticles.vue?vue&type=style&index=0&id=30013515&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30013515",
  null
  
)

export default component.exports